import { RowDataTransaction } from "../../../components/TransactionPage/types";
import { ThProps } from "../../../components/TransactionPage/TransactionPage";
import DataDisplayTab from "../../DataDisplayTab";
import { ReactNode } from "react";
import { TransactionTypes } from "../../DataDisplayTable/TransactionTable";
import AllTab from "./Tabs/AllTab";
import CashTab from "./Tabs/CashTab";
import CoinsTab from "./Tabs/CoinsTab";

class TransactionDisplayTab extends DataDisplayTab {

    sortBy: keyof RowDataTransaction | null;
    setSorting: { (field: keyof RowDataTransaction): void };
    Th: { ({ children, sortable, reversed, sorted, onSort }: ThProps): JSX.Element };
    rowData: RowDataTransaction[] | null;

    constructor(reverseSortDirection: boolean, sortBy: keyof RowDataTransaction | null, setSorting: { (field: keyof RowDataTransaction): void }, classes: { readonly [key: string]: string }, Th: { ({ children, sortable, reversed, sorted, onSort }: ThProps): JSX.Element }, rowData: RowDataTransaction[] | null, rows: JSX.Element[]) {
        super(reverseSortDirection, classes, rows)
        this.sortBy = sortBy
        this.setSorting = setSorting
        this.Th = Th
        this.rowData = rowData
    }

    createTab(tab: string): ReactNode {
        let errMesssage = "Type must be of TransactionTypes: "
        Object.keys(TransactionTypes).forEach((key) => errMesssage += `${key}|`)
        errMesssage = errMesssage.slice(0, errMesssage.length - 1)

        switch (tab) {
            case TransactionTypes.ALL:
                return new AllTab(this.sortBy, this.setSorting, this.Th, this.rowData).create(this.reverseSortDirection, this.classes, this.rows)
            case TransactionTypes.CASH:
                return new CashTab(this.sortBy, this.setSorting, this.Th, this.rowData).create(this.reverseSortDirection, this.classes, this.rows)
            case TransactionTypes.COINS:
                return new CoinsTab(this.sortBy, this.setSorting, this.Th, this.rowData).create(this.reverseSortDirection, this.classes, this.rows)
            default:
                throw new TypeError(errMesssage)
        }
    }
}

export default TransactionDisplayTab
